import { call, put, select } from 'core/middlewares/utilities';
import { getFeatureFlag, IS_HYBRID_CART_ACTIVE } from 'core/services';
import { cart, user } from 'core/use-cases';
import { getLocationPathname } from 'core/utilities';

import type { RootState } from 'core/store';

/**
 * Orchestrate the service BFF initialization flow
 *
 */
export function* bffInit() {
  const pathname = getLocationPathname();
  const resellerId: RootState['user']['data']['resellerId'] = yield select(
    (rootState: RootState) => rootState.user.data.resellerId,
  );
  const isCeased: RootState['user']['data']['isCeased'] = yield select(
    (rootState: RootState) => rootState.user.data.isCeased,
  );

  const routesThatShouldNotInitialize = ['40', '50', 'process', 'indisponivel', 'error'];
  const hasRoute = routesThatShouldNotInitialize.some((route) => pathname.includes(route));

  if (hasRoute) {
    return;
  }

  const isHybridCartActive: boolean = yield call(getFeatureFlag, {
    flag: IS_HYBRID_CART_ACTIVE,
    defaultValue: false,
    resellerId,
  });

  const pageNotDoGetLastCart = ['checkout', 'carrinho'].some((elemento) =>
    pathname.includes(elemento),
  );

  const pageNotDoGetCart = ['carrinho'].some((elemento) => pathname.includes(elemento));

  yield put(user.actions.creditFetch.request());

  if (isHybridCartActive && !pageNotDoGetLastCart && !isCeased) {
    yield put(cart.actions.lastCartFetch.request());

    return;
  }
  if (!pageNotDoGetCart) {
    yield put(cart.actions.cartFetch.request());
  }
}
